import adhocAPI from "@/api/products/adhoc";
import moment from 'moment';

const state = () => ({
  adhocLineItems: [],
  adhocLineItemsLoading: false,
  createAdhocLoading: false,
  currentAdhocInvoice: {
    lineItems: [],
  },
  deliveryAddressLoading: false,
  adhocCreateInvoiceOpen: false,
  isUpfrontCosts: false,
  isModemUpdate: false,
  adhocInvoices: [],
  adhocInvoicesLoading: false,
});

const mutations = {
  setAdhocLineItems(state,data){ state.adhocLineItems = data; },
  setAdhocLineItemsLoading(state,data){ state.adhocLineItemsLoading = data; },
  setCreateAdhocLoading(state,data){ state.createAdhocLoading = data; },
  setCurrentAdhocInvoiceLineItems(state,data){ state.currentAdhocInvoice.lineItems = data; },
  setDeliveryAddressLoading(state,data){ state.deliveryAddressLoading = data; },
  setIsUpfrontCosts(state,data){ state.isUpfrontCosts = data; },
  setIsModemUpdate(state,data){ state.isModemUpdate = data; },
  setAdhocCreateInvoiceOpen(state,data){ state.adhocCreateInvoiceOpen = data; },
  setAdhocInvoices(state,data){ state.adhocInvoices = data; },
  setAdhocInvoicesLoading(state,data){ state.adhocInvoicesLoading = data; },
};

const actions = {
  async fetchAdhocLineItems({commit,dispatch},p_kind){
    commit('setAdhocLineItemsLoading',true);
    try{
      const res = await adhocAPI.fetchAdhocLineItems(p_kind);
      if(res.status===200){
        commit('setAdhocLineItems',res.data);
        commit('setAdhocLineItemsLoading',false);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async fetchAdhocInvoices({commit,dispatch},acc_id){
    commit('setAdhocInvoicesLoading',true);
    try{
      const res = await adhocAPI.fetchAdhocInvoices(acc_id);
      if(res.status===200){
        commit('setAdhocInvoicesLoading',false);
        commit('setAdhocInvoices',res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async downloadInvoice({dispatch},invoice){
    try{
      const res = await adhocAPI.downloadInvoice(invoice.download);

      console.log(invoice);
      if(res.status===200){
        const url = window.URL.createObjectURL(res.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${invoice.download}-${invoice.datetime}.pdf`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      console.log(err);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async createAdhocInvoice({commit,dispatch},{acc_id,data}){
    commit('setCreateAdhocLoading',true);
    try{
      const res = await adhocAPI.createAdhocInvoice(acc_id,data);
      if(res.status===200){
        commit('setCreateAdhocLoading',false);
        commit('setCurrentAdhocInvoiceLineItems',[]);
        dispatch("alerts/setAlert", {type: "success",message: "Ad hoc created and sent successfully!"}, { root: true });
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        throw res.response.data.message;
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      throw err;
    }
  },
  async updateDeliveryAddress({commit,dispatch},{p_id,address}){
    commit('setDeliveryAddressLoading',true);
    try{
      const res = await adhocAPI.updateDeliveryAddress(p_id,address);
      if(res.status===200){
        commit('setDeliveryAddressLoading',false);
        dispatch("alerts/setAlert", {type: "success",message: "Delivery address updated successfully!"}, { root: true });
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
};

const emptyCategory = (cat)=>{
  return (cat===null||cat===undefined||cat==='')?'Uncategorised':cat;
}

const titleCase = (str)=>{
  str = str.toLowerCase().split('_');
  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
  }
  return str.join(' ');
}

const getters = {
  getAdhocLineItems: (state)=>(type)=>{ 
    let categories = [];
    let lineItems = [];
    const filterAdhocItems = state.adhocLineItems.filter(e=>{
      if(['adhoc'].includes(type)) { return e.ad_hoc; }
      return e;
    });
    filterAdhocItems.forEach(item => {
      if(categories.indexOf(emptyCategory(item.category))===-1){
        categories.push(emptyCategory(item.category));
        lineItems.push({name:titleCase(emptyCategory(item.category)),items:[],groups:{},hasGroups:false});
      }
      let catArr = lineItems[categories.indexOf(emptyCategory(item.category))];
      if(item.display_group!==null){
        catArr.groups[item.display_group] = {
          name: titleCase(item.display_group),
          items: [],
          selected: false,
          current: {},
        };
      }
    });
    filterAdhocItems.forEach(item => {
      let catArr = lineItems[categories.indexOf(emptyCategory(item.category))];
      if(item.display_group!==null){ catArr.hasGroups = true; }
      catArr = (item.display_group!==null)?catArr.groups[item.display_group].items:catArr.items;
      catArr.push({
        name: item.name,
        price: parseFloat(item.standard_price).toFixed(2),
        id: item.id,
        quantity: 0,
        total: 0,
        selected: false,
        stock: item.stock_level,
        kind: item.product_kind.toLowerCase(),
        available: item.available,
        allow_custom_price: item.allow_custom_price,
      });
    });
    return lineItems;
  },
  getCurrentAdhoc: (state)=>{ return state.currentAdhocInvoice; },
  getAdhocInvoices: (state)=>{
    state.adhocInvoices = state.adhocInvoices.reverse();
    return state.adhocInvoices.map(e=>{
      return {
        datetime: moment(e.creation_timestamp).format('YYYY/MM/DD HH:mm'),
        reference: (e.reference!==null)?e.reference:`${e.id} (${e.username})`,
        total: `£${parseFloat(e.total).toFixed(2)}`,
        download: e.id,
        order_status: e.order_status,
        downloadLoading: false,
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  